export default __webpack_public_path__ + "static/resources-winter-workshop-7120869abea1040a1eadb951500d3d91.jpg";